import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    editing: {
        editMode: false,
        videoId: ""
    }
}

const videoSlice = createSlice({
    name: 'video',
    initialState,
    reducers: {
        startEditing: (state, action) => {
            state.editing.videoId = action.payload
            state.editing.editMode = true
        },
        endEditing: (state, action) => {
            state.editing.videoId = "";
            state.editing.editMode = false;
            
        } 
    }
})

export const {startEditing, endEditing} = videoSlice.actions;
export default videoSlice.reducer;